// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2703":"d200a413","3332":"d200a413","5171":"d200a413","6980":"d200a413"}[chunkId] + ".chunk.css";
};